export enum MediaPartType {
  MainImage = 'main',
  ShopImage = 'shopImage',
  BackCoverImage = 'backCoverImage',
  LogoImage = 'logoImage',
}
